<script setup lang="ts">

const { t } = useI18n()

</script>

<script lang="ts">
export default {
  name: 'WhoWeAreHero'
}
</script>

<template>
  <section class="bg-pine-600 lg:py-90 lg:px-90 py-56 px-24">
    <div class="max-w-screen-lg mx-auto flex flex-col md:flex-row items-center justify-between gap-48">
      <div class="w-full md:w-1/2 max-w-[445px]">
        <h2 class="lg:display-3 display-4 text-lime-600 mb-24">
          {{ t('title') }}
        </h2>

        <p class="text-white lg:hl-3-m body-1-m">
          {{ t('description') }}
        </p>
      </div>

      <div class="w-full md:w-1/2">
        <img
          src="https://media.lahaus.com/statics/static/images/who-we-are/hero.png?auto=compress,enhance,format"
          alt="Equipo de LaHaus"
          class="w-full h-auto rounded-24">
      </div>
    </div>
  </section>
</template>
<i18n src="./i18n.json" lang="json"></i18n>
